import React, { useSelector } from 'react';

import {
  Box,
  Card,
  CardHeader,
  CardContent,
  makeStyles,
} from '@material-ui/core';

import Divider from '../Divider';
import Button from '../Button';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 402,
    maxWidth: 312,
    boxShadow: '0px 13px 18px rgba(0, 0, 0, 0.15)',
    borderRadius: 2,
    [theme.breakpoints.up('xs')]: {
      width: 270,
    },
    [theme.breakpoints.up('xs_375')]: {
      width: 323,
    },
    [theme.breakpoints.up('sm')]: {
      width: 510,
    },
    [theme.breakpoints.up('md')]: {
      width: 271,
    },
    [theme.breakpoints.up('lg')]: {
      width: 312,
    },
  },
  header: {
    height: 74,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f1f1f1',
    borderRadius: '0 0 20% 20%',
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#004987',
    textAlign: 'center',
  },
  cardContent: {
    [theme.breakpoints.up('sm')]: {
      padding: '24px',
    },
  },
}));

const PlanCard = React.forwardRef((props, ref) => {
  const {
    plan,
    maxWidth,
    width,
    handleClick,
    handlePlanInfo,
    smallCard = false,
  } = props;

  const classes = useStyles();

  const { insuranceCoverages, longDesc, price } = plan || {};

  const coverages = insuranceCoverages.slice(0, 4);

  return (
    <Card
      className={classes.root}
      ref={ref}
      style={{
        ...(width || maxWidth ? { maxWidth, width } : {}),
      }}
    >
      <CardHeader
        title={`PLAN ${longDesc && longDesc.replace(/plan/gi, '')}`}
        classes={{
          root: classes.header,
          title: classes.headerTitle,
        }}
      />

      <CardContent
        classes={{
          root: classes.cardContent,
        }}
      >
        {!smallCard && (
          <React.Fragment>
            <Box
              component='span'
              display='block'
              textAlign='center'
              color='#323232'
            >
              Principales coberturas
            </Box>
            <Divider my='16px' />
          </React.Fragment>
        )}
        {coverages.map((coverage) => (
          <Box
            key={coverage.insuranceCoverageId}
            display='flex'
            justifyContent={smallCard ? 'center' : 'space-between'}
            alignItems='baseline'
            mb='20px'
            fontSize={13}
          >
            <Box display={smallCard ? 'none' : 'flex'}>
              <Box width='15px' mr='5px'>
                <img
                  src={require('../../img/check.svg')}
                  alt=''
                  style={{ width: '100%', height: 'auto' }}
                />
              </Box>
              <Box component='span' color='#616161' fontWeight={300}>
                {coverage.description}
              </Box>
            </Box>
            <Box ml='10px' color='#323232'>
              ${coverage.amount}
            </Box>
          </Box>
        ))}
        <Box display='flex' alignItems='center' width='100%'>
          <Divider width='100%' />
          <div onClick={() => handlePlanInfo(plan, '/planInfo')}>
            <div className='infoButton'>
              <img src={require('./../../img/plus.svg')} alt='' /> Info
            </div>
          </div>
          <Divider width='100%' />
        </Box>
        <Box textAlign='center'>
          <Box
            className='monthly-price'
            fontSize={smallCard ? 16 : 20}
            fontWeight='fontWeightMedium'
          >
            $
            <Box
              component='span'
              fontWeight='fontWeightBold'
              fontSize={smallCard ? 24 : 38}
            >
              {parseFloat(price).toFixed(0)}
            </Box>
            /mes
          </Box>
          <Button
            onClick={() => handleClick(plan)}
            theme='rounded'
            width={smallCard ? 99 : 112}
            height={smallCard ? 32 : 38}
          >
            {smallCard ? 'Contratar' : 'CONTRATAR'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
});

export default PlanCard;
